module.exports = __webpack_public_path__ + "img/menu.4b344c6c.svg";